import { LettersImage } from '@approvalmax/ui';
import { Button, Flex, Form, Text, TextField } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import trim from 'lodash/trim';
import { memo } from 'react';
import { useForm } from 'react-hook-form';
import { useResetPassword } from 'shared/data/webApp/v1';
import { z } from 'zod';

import { emailFieldName } from './Content.constants';
import { messages } from './Content.messages';
import { schema } from './Content.schema';

export const Content = memo(() => {
    const [externalEmail] = hooks.useQueryParam('email');

    const {
        mutate: resetPassword,
        isLoading: isLoadingResetPassword,
        isSuccess: isSuccessResetPassword,
    } = useResetPassword();

    const form = useForm<z.infer<typeof schema>>({
        defaultValues: {
            [emailFieldName]: externalEmail || '',
        },
        resolver: zodResolver(schema),
    });

    const email = form.watch(emailFieldName);

    const onSubmit = form.handleSubmit((data) => {
        resetPassword({
            body: {
                ...data,
                sendConfirmationLink: true,
            },
        });
    });

    return (
        <Form form={form} onSubmit={onSubmit}>
            {isSuccessResetPassword ? (
                <Flex direction='column' spacing='24' alignItems='center'>
                    <LettersImage width={100} height={100} />

                    <Text font='headline' fontSize='small' fontWeight='medium' as='h1' textAlign='center'>
                        {messages.titleSuccess}
                    </Text>

                    <Text font='body' textAlign='center'>
                        {messages.descriptionSuccess({ email })}
                    </Text>
                </Flex>
            ) : (
                <Flex direction='column' spacing='24'>
                    <Text font='headline' fontSize='small' fontWeight='medium' as='h1' textAlign='center'>
                        {messages.title}
                    </Text>

                    <TextField
                        name={emailFieldName}
                        placeholder={messages.emailPlaceholder}
                        label={messages.emailLabel}
                        required
                        transform={trim}
                        inputMode='email'
                        initFocus
                    />

                    <Button type='submit' color='blue80' size='large' block progress={isLoadingResetPassword}>
                        {messages.resetButton}
                    </Button>
                </Flex>
            )}
        </Form>
    );
});

Content.displayName = 'Content';
